/** @module Auth0BetaOptInFeatureMachine */
/* eslint-disable import/extensions */
import Auth0BetaOptInFeatureBase from './auth0-beta-opt-in-feature-base.mjs';

class Auth0BetaOptInFeatureMachine extends Auth0BetaOptInFeatureBase {
  constructor(options) {
    super(options);
    console.log(`Auth0BetaOptInFeatureMachine init for flag => "${JSON.stringify(options)}"`);
    // default state
    this._isMachineEnabled = false;
  }

  optIn() {
    this._isMachineEnabled = true;
    this._saveOptInOptionsState({ machineEnabled: this._isMachineEnabled });
  }

  optOut() {
    this._isMachineEnabled = false;
    this._saveOptInOptionsState({ machineEnabled: this._isMachineEnabled });
  }

  async isOptedIn() {
    this.refresh();
    return this._isMachineEnabled ?? false;
  }

  _restoreStateFromDisk() {
    const currentPersistedState = this._persistedBetaOptInData;
    this._isMachineEnabled = currentPersistedState?.machineEnabled ?? false;
  }

  get supportsUserOptIn() {
    return true;
  }
}

export default Auth0BetaOptInFeatureMachine;
